// extracted by mini-css-extract-plugin
module.exports = {"ModalFooter":"ModalFooter_ModalFooter__TXlT7","ModalFooter__secondary":"ModalFooter_ModalFooter__secondary__1kRIz"};